import React, { useEffect, useState, useRef, useCallback } from 'react';
import { headStyle, cardStyle, hrStyle, buttonStyle, headStyleInverted, backgroundStyle, lightColor, verticalCenter } from '../../css/styling';
import { Button, IconButton, Input } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ScreenshotMonitorIcon from '@mui/icons-material/ScreenshotMonitor';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';

const INSIGHTSLIST = [
    { id: "ULEZcomp", title: "ULEZ Vehicle Compliance", src: "https://app.powerbi.com/view?r=eyJrIjoiNDU4YTYyNGYtZmY3ZC00YzY2LWFjNzMtY2ViNWY3YjExZGZlIiwidCI6IjY5OWFjZTY3LWQyZTQtNGJjZC1iMzAzLWQyYmJlMmI5YmJmMSJ9", description: "Vehicle compliance in ultra-low emimssion zones.", keywords: "ULEZ,ultra,low,emision,zone,compliance" },
    { "id": "TrafficAQ", "title": "Air Quality and Congestion", "src": "https://app.powerbi.com/view?r=eyJrIjoiNDlmMWQ2YTYtYzM3OS00NTgxLWI4ZWItNDk4YjIxZTNjNGRiIiwidCI6IjY5OWFjZTY3LWQyZTQtNGJjZC1iMzAzLWQyYmJlMmI5YmJmMSJ9", "description": "Pollutant levels in correlation to road congestion.", "keywords": "air quality,pollution,PM2.5,NOX,NO2,O2" }
]

const card = (v) => <>
    <div>
        <Typography variant="h5" gutterBottom>
            {v.title}
        </Typography>
        <Typography style={{ padding: '5px' }} sx={{ fontSize: 14 }} component="div">
            {v.description}
        </Typography>
        <Typography style={{ padding: '5px' }} variant="h7" color="text.secondary" component="div">
            {v.keywords}
        </Typography>
    </div>
</>

function Insights() {

    const [insights, setInsights] = useState(null);
    const [filter, setFilter] = useState("");

    return <>
        <Box sx={{ width: '100%', textAlign: '-webkit-center' }}>
            {/* <input className='tfieldStyle' style={{...cardStyle}} onChange={(e) => { setFilter(e.target.value) }} /> */}
            {/* <TextField id="filled-basic" label="Filled" variant="filled" /> */}
            <div>FILTER
                <input className='tfieldStyle' style={{ margin: '30px' }} id="standard-basic" label="Keyword Filter" variant="standard"
                    onChange={(e) => { setFilter(e.target.value) }} />
            </div>
            <div style={{ overflowY: 'auto', height:'calc(100vh - 35vh)' }}>
                {INSIGHTSLIST.map((v,i) => {
                    if (filter === "" || v.keywords.toLowerCase().includes(filter.toLowerCase()))
                        return <div key={i} className='buttonexotic' style={{ ...cardStyle, marginBottom: '20px', maxWidth: 800, minWidth: 275 }} onClick={() => setInsights(v)} variant="outlined"  >{card(v)}</div>
                }
                )}
            </div>
        </Box>

        {/* <Button onClick={() => setInsights(INSIGHTSLIST[0])}>ULEZ Compliance</Button> */}

        {insights ?
            <div style={{ ...backgroundStyle, position: 'fixed', top: '60px', left: '0px', height: '100vh', width: '100%', right: '60px' }}>
                <iframe id='iframecurrent' src={insights.src} style={{ width: 'calc(100% - 55px)', height: 'calc(100% - 80px)', padding: '10px', marginRight: '60px', border: 'none', borderRadius: '15px' }}></iframe>
                <IconButton style={{ color: 'red', borderRadius: '1px', right: '4px', top: '10px', zIndex: 10000, position: 'absolute' }} onClick={() => setInsights(null)} >
                    <CloseIcon />
                </IconButton>

                {/* <Button >Snp</Button>
                <IconButton
                    style={{ color: 'red', borderRadius: '1px', right: '4px', top: '10px', zIndex: 10000, position: 'absolute' }}
                    onClick={() => {
                        var c = document.getElementById('iframecurrent');
                        var t = c.getContext('2d');
                        window.open('', document.getElementById('the_canvas_element_id').toDataURL());
                    }}>
                    <ScreenshotMonitorIcon />
                </IconButton> */}

            </div> : null}

    </>
}

export default Insights;